module.exports = __webpack_public_path__ + "media/images/calendar/november-19a8e846b91a2bb401a4fc3a30f5d4cf.jpg";